import { useState } from 'react'

import { TIME_INPUT_FORMAT_HINT, TimePicker } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, text, time } from '../Controls'

export function TimePickerUsage() {
  const [props, setProps] = useState(() =>
    controls()
      .add(boolean('clearable', true))
      .add(boolean('disabled', false))
      .add(text('formatHint', TIME_INPUT_FORMAT_HINT))
      .add(text('label', 'Time picker'))
      .add(time('maxValue', null))
      .add(time('minValue', null))
      .add(text('placeholder', 'Select time'))
      .add(time('value', null))
  )

  function handleChange(nextYear) {
    setProps(controls => controls.setValue('value', nextYear))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={TimePicker}
        name='TimePicker'
        onChange={handleChange}
      />
      <ComponentProps name='TimePicker' value={props} onChange={setProps} />
    </>
  )
}
